module.exports = "<div class=et-error-page ng-show=showWhile> <div class=error-content> <img src=" + require("/home/jenkins/workspace/test_BL_front/src/assets/images/cartoon.png") + " alt={{msg}}> <p class=text-center>{{msg}}</p> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/components/errorPage/errorPage.html
// module id = r/E4
// module chunks = 0